import { render } from "./WelcomeBanner.vue?vue&type=template&id=7fb6e25e&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"

import "./WelcomeBanner.vue?vue&type=style&index=0&id=7fb6e25e&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb6e25e"]])

export default __exports__